(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequireda16"];
var parcelRegister = parcelRequire.register;
parcelRegister("g7Te6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "Items", function () { return $bbd8239e817933b5$export$b4399d239416b67f; });
$parcel$export(module.exports, "make", function () { return $bbd8239e817933b5$export$dd44f18ab656f3bb; });
$parcel$export(module.exports, "$$default", function () { return $bbd8239e817933b5$export$aa541d093b11ace2; });
$parcel$export(module.exports, "default", function () { return $bbd8239e817933b5$export$aa541d093b11ace2; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $1xf0g = parcelRequire("1xf0g");

var $3QSSt = parcelRequire("3QSSt");

var $dJhID = parcelRequire("dJhID");

var $hBcYV = parcelRequire("hBcYV");

var $a5Xhm = parcelRequire("a5Xhm");

var $3QcL7 = parcelRequire("3QcL7");

var $jsBjX = parcelRequire("jsBjX");

var $8E2YL = parcelRequire("8E2YL");

var $87Cf3 = parcelRequire("87Cf3");

var $b8WNX = parcelRequire("b8WNX");

var $iWHC4 = parcelRequire("iWHC4");

var $hM6fK = parcelRequire("hM6fK");
function $bbd8239e817933b5$var$NavMenuOverlay$Items(Props) {
    var activeValue = Props.activeValue;
    var match = $8E2YL.use(undefined);
    $hBcYV.useRouter(undefined);
    var ctx = $3QcL7.use(undefined);
    var match$1 = $g85JO.useState(function() {
        return ctx.isModalOpen;
    });
    var setEverBeenOpen = match$1[1];
    var hasEverBeenOpen = match$1[0];
    $g85JO.useEffect(function() {
        $iv6Yc._1(setEverBeenOpen, function(previous) {
            if (previous) return true;
            else return ctx.isModalOpen;
        });
    }, [
        ctx.isModalOpen
    ]);
    return $i7mYY.mapWithIndex($i7mYY.keepWithIndex(match.config.categories, function(category, value) {
        if (value === activeValue) return true;
        else return hasEverBeenOpen;
    }), function(value, category) {
        return /*#__PURE__*/ $g85JO.createElement($jsBjX.Content.make, {
            value: value,
            dataTestId: "nav-menu-content-l1",
            className: $ezf3v.prefix("h-full"),
            children: $1xf0g.isIndexNode(category) ? /*#__PURE__*/ $g85JO.createElement($87Cf3.make, {
                disabled: value !== activeValue,
                category: category
            }) : /*#__PURE__*/ $g85JO.createElement($a5Xhm.make, {
                level: 1,
                category: category,
                disabled: value !== activeValue
            }),
            key: category.id
        });
    });
}
$bbd8239e817933b5$var$NavMenuOverlay$Items.displayName = "NavMenuOverlay.Items";
var $bbd8239e817933b5$var$make = /*#__PURE__*/ $g85JO.memo($bbd8239e817933b5$var$NavMenuOverlay$Items);
var $bbd8239e817933b5$export$b4399d239416b67f = {
    make: $bbd8239e817933b5$var$make
};
function $bbd8239e817933b5$var$NavMenuOverlay(Props) {
    var contentHeight = Props.contentHeight;
    var setContentHeight = Props.setContentHeight;
    var onMouseLeave = Props.onMouseLeave;
    var onMouseEnter = Props.onMouseEnter;
    var ctx = $3QcL7.use(undefined);
    var match = $8E2YL.use(undefined);
    var config = match.config;
    var match$1 = $hBcYV.useRouter(undefined);
    var quickViewUnderlyingRoute = match$1.quickViewUnderlyingRoute;
    var route = match$1.route;
    var handleResize = $g85JO.useCallback(function(width) {
        return function(height) {
            return $iv6Yc._1(setContentHeight, function(param) {
                return height;
            });
        };
    }, [
        setContentHeight
    ]);
    var activeValue = $g85JO.useMemo(function() {
        return $2whNH.map(ctx.currentL1, function(category) {
            return config.categories.indexOf(category);
        });
    }, [
        ctx.currentL1
    ]);
    var previousActiveValue = $2whNH.getWithDefault($3QSSt.usePreviousSome(activeValue), 0);
    var value = $2whNH.getWithDefault(activeValue, previousActiveValue);
    $g85JO.useEffect(function() {
        var preload = function preload(param) {
            $iv6Yc._1($hM6fK.preload, undefined);
            return $iv6Yc._1($b8WNX.preload, undefined);
        };
        window.addEventListener("mousemove", preload);
        return function(param) {
            window.removeEventListener("mousemove", preload);
        };
    }, []);
    var tmp = {
        contentHeight: contentHeight,
        children: /*#__PURE__*/ $g85JO.createElement($jsBjX.Container.make, {
            value: value,
            direction: activeValue === undefined ? /* NoMotion */ 2 : /* Horizontal */ 1,
            animate: true,
            children: /*#__PURE__*/ $g85JO.createElement($bbd8239e817933b5$var$make, {
                activeValue: value,
                contentHeight: contentHeight,
                onItemResize: handleResize
            })
        })
    };
    if (activeValue !== undefined) tmp.activeValue = activeValue;
    if (onMouseLeave !== undefined) tmp.onMouseLeave = $loT9g.valFromOption(onMouseLeave);
    if (onMouseEnter !== undefined) tmp.onMouseEnter = $loT9g.valFromOption(onMouseEnter);
    var tmp$1;
    var exit = 0;
    var exit$1 = 0;
    if (quickViewUnderlyingRoute !== undefined && !(typeof quickViewUnderlyingRoute === "number" || quickViewUnderlyingRoute.TAG !== /* PDP */ 2)) exit = 1;
    else exit$1 = 2;
    if (exit$1 === 2) {
        if (typeof route === "number" || route.TAG !== /* PDP */ 2) tmp$1 = null;
        else exit = 1;
    }
    if (exit === 1) tmp$1 = /*#__PURE__*/ $g85JO.createElement($hM6fK.make, {});
    var tmp$2;
    tmp$2 = typeof route === "number" || route.TAG !== /* QuickView */ 3 ? null : /*#__PURE__*/ $g85JO.createElement($b8WNX.make, {});
    return /*#__PURE__*/ $g85JO.createElement($dJhID.make, {
        componentName: "NavMenuOverlay",
        children: null
    }, /*#__PURE__*/ $g85JO.createElement($iWHC4.make, tmp), tmp$1, tmp$2);
}
$bbd8239e817933b5$var$NavMenuOverlay.displayName = "NavMenuOverlay";
var $bbd8239e817933b5$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($bbd8239e817933b5$var$NavMenuOverlay);
var $bbd8239e817933b5$export$aa541d093b11ace2 = $bbd8239e817933b5$export$dd44f18ab656f3bb;
 /* make Not a pure module */ 
});
parcelRegister("a5Xhm", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $75985a9960b7d962$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $38gYA = parcelRequire("38gYA");

var $5bEXW = parcelRequire("5bEXW");

var $1a0pQ = parcelRequire("1a0pQ");

var $hBcYV = parcelRequire("hBcYV");

var $aSJcu = parcelRequire("aSJcu");

var $3QcL7 = parcelRequire("3QcL7");

var $7Fi8J = parcelRequire("7Fi8J");

var $g0zNe = parcelRequire("g0zNe");

var $jsBjX = parcelRequire("jsBjX");

var $8E2YL = parcelRequire("8E2YL");
function $75985a9960b7d962$var$make(Props) {
    var level = Props.level;
    var category = Props.category;
    var disabled = Props.disabled;
    var ctx = $3QcL7.use(undefined);
    var match = $8E2YL.use(undefined);
    var config = match.config;
    $hBcYV.useRouter(undefined);
    var items = $1a0pQ.useItems(category, undefined);
    $aSJcu.use(undefined);
    var scrollableContainerRef = $g85JO.useRef(null);
    var match$1 = $g85JO.useState(function() {
        return ctx.currentFullPath;
    });
    var setRelativePath = match$1[1];
    var relativePath = match$1[0];
    $g85JO.useEffect(function() {
        $iv6Yc._1(setRelativePath, function(previous) {
            if ($i7mYY.some(ctx.currentFullPath, function(c) {
                return c.id === category.id;
            })) return ctx.currentFullPath;
            else return previous;
        });
    }, [
        ctx.currentFullPath
    ]);
    var __categoryIndex = $2whNH.map($2whNH.keep($2whNH.flatMap(items, function(items) {
        return $i7mYY.getIndexBy(items, function(i) {
            return $7bjme.equal(i.category.id, $2whNH.map($2whNH.orElse($i7mYY.get(relativePath, level), $i7mYY.get(relativePath, level - 1 | 0)), function(c) {
                return c.id;
            }));
        });
    }), function(i) {
        return i >= 0;
    }), function(i) {
        return i + 1 | 0;
    });
    var match$2 = $g85JO.useState(function() {
        return $2whNH.getWithDefault(__categoryIndex, 0);
    });
    var setCategoryIndex = match$2[1];
    $g85JO.useEffect(function() {
        $iv6Yc._1(setCategoryIndex, function(previous) {
            return $2whNH.getWithDefault(__categoryIndex, previous);
        });
    }, [
        __categoryIndex,
        disabled
    ]);
    var match$3 = ctx.mode;
    var sidebarWidth = match$3 ? 120 : 200;
    var isAnyItemVisible = $i7mYY.some($2whNH.getWithDefault(items, []), function(i) {
        if (i.isHidden === false) return i.isParentItself === false;
        else return false;
    });
    var canRenderSidebar = (ctx.threeColumnLayout || level === 1) && config.settings.linksAsSidebar && isAnyItemVisible;
    var canRenderNextLevel = level !== relativePath.length && level < (ctx.maxLevels - 1 | 0);
    var tmp;
    if (canRenderSidebar) {
        var tmp$1 = {
            level: level,
            className: $ezf3v.prefix("flex-shrink-0"),
            style: {
                width: $ezf3v.intToPx(sidebarWidth)
            }
        };
        if (items !== undefined) tmp$1.items = $loT9g.valFromOption(items);
        tmp = /*#__PURE__*/ $g85JO.createElement($7Fi8J.make, tmp$1);
    } else tmp = null;
    return /*#__PURE__*/ $g85JO.createElement("div", {
        ref: $5bEXW.Ref.domRef(scrollableContainerRef),
        className: $ezf3v.prefix($1TRFX.make([
            "flex h-full relative",
            ctx.mode === /* Hamburger */ 1 ? "overflow-hidden" : ""
        ]))
    }, tmp, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("flex-grow relative")
    }, /*#__PURE__*/ $g85JO.createElement($jsBjX.Container.make, {
        value: match$2[0],
        direction: /* Vertical */ 0,
        disabled: disabled,
        children: $i7mYY.mapWithIndex($2whNH.getWithDefault(items, []), function(index, param) {
            var category = param.category;
            return /*#__PURE__*/ $g85JO.createElement($jsBjX.Content.make, {
                value: index + 1 | 0,
                dataTestId: "nav-menu-content-l2",
                className: $ezf3v.prefix("h-full"),
                children: canRenderNextLevel ? /*#__PURE__*/ $g85JO.createElement($75985a9960b7d962$var$make, {
                    level: level + 1 | 0,
                    category: category,
                    disabled: disabled
                }) : /*#__PURE__*/ $g85JO.createElement($38gYA.make, {
                    children: /*#__PURE__*/ $g85JO.createElement($g0zNe.make, {
                        allCategories: config.categories,
                        category: category,
                        scrollableContainerRef: scrollableContainerRef
                    }),
                    className: $ezf3v.prefix("relative h-full no-scrollbar pb-20"),
                    rememberScrollPosition: false
                }),
                key: category.id
            });
        })
    })));
}
$75985a9960b7d962$var$make.displayName = "make";
var $75985a9960b7d962$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($75985a9960b7d962$var$make);
 /* make Not a pure module */ 
});
parcelRegister("38gYA", function(module, exports) {

$parcel$export(module.exports, "useScrollableContext", function () { return $247f49975e2c6903$export$c8bd6c217b070147; });
$parcel$export(module.exports, "make", function () { return $247f49975e2c6903$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $kQvlq = parcelRequire("kQvlq");

var $3tS2g = parcelRequire("3tS2g");

var $gWwbb = parcelRequire("gWwbb");

var $iXXhl = parcelRequire("iXXhl");

var $gCzsf = parcelRequire("gCzsf");

var $5bEXW = parcelRequire("5bEXW");

var $efwy1 = parcelRequire("efwy1");

var $2XXXw = parcelRequire("2XXXw");
$gWwbb.polyfill();
var $247f49975e2c6903$var$context = /*#__PURE__*/ $g85JO.createContext({
    element: undefined
});
var $247f49975e2c6903$var$provider = $247f49975e2c6903$var$context.Provider;
function $247f49975e2c6903$var$Scrollable$Provider(Props) {
    var children = Props.children;
    var element = Props.element;
    return /*#__PURE__*/ $g85JO.createElement($247f49975e2c6903$var$provider, {
        value: {
            element: element
        },
        children: children
    });
}
$247f49975e2c6903$var$Scrollable$Provider.displayName = "Scrollable.Provider";
var $247f49975e2c6903$export$2881499e37b75b9a = {
    context: $247f49975e2c6903$var$context,
    provider: $247f49975e2c6903$var$provider,
    make: $247f49975e2c6903$var$Scrollable$Provider
};
function $247f49975e2c6903$export$c8bd6c217b070147(param) {
    return $g85JO.useContext($247f49975e2c6903$var$context);
}
function $247f49975e2c6903$var$Scrollable(Props) {
    var restorationId = Props.restorationId;
    var scrollToRef = Props.scrollToRef;
    var onScrollOpt = Props.onScroll;
    var childrenOpt = Props.children;
    var lockedOpt = Props.locked;
    var fwdRef = Props.fwdRef;
    var classNameOpt = Props.className;
    var onTouchStart = Props.onTouchStart;
    var onTouchMove = Props.onTouchMove;
    var onTouchEnd = Props.onTouchEnd;
    var scrollOffsetOpt = Props.scrollOffset;
    var defaultRestorationPosition = Props.defaultRestorationPosition;
    var inlineOpt = Props.inline;
    var styleOpt = Props.style;
    var stopPropagationOpt = Props.stopPropagation;
    var rememberScrollPositionOpt = Props.rememberScrollPosition;
    var onScroll = onScrollOpt !== undefined ? onScrollOpt : function onScroll(e, wasAutoScroll) {};
    var children = childrenOpt !== undefined ? $loT9g.valFromOption(childrenOpt) : null;
    var locked = lockedOpt !== undefined ? lockedOpt : false;
    var className = classNameOpt !== undefined ? classNameOpt : "";
    var scrollOffset = scrollOffsetOpt !== undefined ? scrollOffsetOpt : 0.0;
    var inline = inlineOpt !== undefined ? inlineOpt : false;
    var style = styleOpt !== undefined ? $loT9g.valFromOption(styleOpt) : {};
    var stopPropagation = stopPropagationOpt !== undefined ? stopPropagationOpt : false;
    var rememberScrollPosition = rememberScrollPositionOpt !== undefined ? rememberScrollPositionOpt : true;
    var match = $efwy1.use(undefined);
    var namespace = match.namespace;
    var scrollRef = $g85JO.useRef(null);
    var isAutoScroll = $g85JO.useRef(false);
    var previousScroll = $g85JO.useRef(0);
    var match$1 = $kQvlq.useSafeTimeout(undefined, undefined);
    var useScrollToTimeout = match$1.setTimeout;
    var match$2 = $kQvlq.useSafeTimeout(undefined, undefined);
    var useRestoreFromPositionTimeout = match$2.setTimeout;
    var match$3 = $kQvlq.useSafeTimeout(undefined, undefined);
    var useAutoScrollTimeout = match$3.setTimeout;
    var match$4 = $kQvlq.useSafeTimeout(undefined, undefined);
    var useScrollLockTimeout = match$4.setTimeout;
    var mergedRef = fwdRef !== undefined ? (0, $iXXhl.default)(scrollRef, fwdRef) : scrollRef;
    var restoration = $2XXXw.useScrollRestoration(restorationId);
    $2whNH.forEach(scrollToRef, function(scrollTo) {
        scrollTo.current = function(el0) {
            useScrollToTimeout(function(param) {
                var el = scrollRef.current;
                if (el == null) return;
                var scrollTop;
                scrollTop = typeof el0 === "number" ? $2whNH.getWithDefault(defaultRestorationPosition, 0.0) : el0.TAG === /* Element */ 0 ? el0._0.offsetTop : el0._0;
                var el$1 = scrollRef.current;
                var options = {
                    top: scrollTop + scrollOffset,
                    left: 0.0,
                    behavior: "smooth"
                };
                if (!(el$1 == null)) el$1.scrollTo(options);
                if (restorationId !== undefined && rememberScrollPosition) {
                    previousScroll.current = scrollTop | 0;
                    return $2XXXw.setCurrentScroll(namespace, restorationId, {
                        TAG: /* Pixels */ 0,
                        _0: scrollTop | 0
                    });
                }
            }, 0);
        };
    });
    var onScroll$1 = function onScroll$1(param) {
        window.dispatchEvent(new Event("scroll"));
        $2whNH.map($loT9g.nullable_to_opt(scrollRef.current), function(el) {
            var scrollTop = el.scrollTop | 0;
            var isBlocking = $2XXXw.isBlockingOnScrollEvent(undefined);
            var isGreaterThanStart = $2whNH.mapWithDefault($2whNH.keep(defaultRestorationPosition, function(a) {
                return a > 0.0;
            }), true, function(start) {
                return scrollTop > start;
            });
            var isEnabled = !isBlocking && isGreaterThanStart;
            if (restorationId !== undefined && rememberScrollPosition && isEnabled) {
                previousScroll.current = scrollTop;
                return $2XXXw.setCurrentScroll(namespace, restorationId, {
                    TAG: /* Pixels */ 0,
                    _0: scrollTop
                });
            }
        });
    };
    var restoreFromLock = function restoreFromLock(lock) {
        return $2whNH.getWithDefault($2whNH.map($loT9g.nullable_to_opt(scrollRef.current), function(scrollEl) {
            var lockEl = lock.element;
            if ($3tS2g.isDescendent(scrollEl, lockEl)) {
                useScrollLockTimeout(function(param) {
                    var currentScrollPosition = scrollEl.scrollTop;
                    var currentElementTop = lockEl.getBoundingClientRect().top;
                    var originalElementTop = lock.boundingClientRect.top;
                    var amountToScroll = currentElementTop - originalElementTop;
                    var newScrollPosition = currentScrollPosition + amountToScroll;
                    scrollEl.scrollTop = newScrollPosition;
                    onScroll$1(undefined);
                }, 0);
                return true;
            } else return false;
        }), false);
    };
    var restoreFromPosition = function restoreFromPosition1(retryOpt, el, position) {
        var retry = retryOpt !== undefined ? retryOpt : 0;
        if (typeof position === "number") {
            var targetScroll = Math.max(scrollOffset, $2whNH.getWithDefault(defaultRestorationPosition, 0.0)) | 0;
            var scrollTop = $2XXXw.getClosestBreakingPoint(previousScroll.current, targetScroll);
            el.scrollTop = scrollTop;
            return;
        }
        if (position.TAG !== /* Pixels */ 0) return;
        var scrollTop$1 = Math.max(scrollOffset, position._0);
        var height = $2whNH.getWithDefault($2whNH.map($2whNH.map($i7mYY.get(Array.prototype.slice.call(el.children), 0), function(prim) {
            return prim.getBoundingClientRect();
        }), function(prim) {
            return prim.height;
        }), 100000);
        if (scrollTop$1 === 0 || scrollTop$1 <= height || retry > 4) {
            el.scrollTop = scrollTop$1;
            return;
        } else return useRestoreFromPositionTimeout(function(param) {
            restoreFromPosition(retry + 1 | 0, el, position);
        }, 16);
    };
    var setisAutoScroll = function setisAutoScroll(param) {
        isAutoScroll.current = true;
        useAutoScrollTimeout(function(param) {
            isAutoScroll.current = false;
        }, 100);
    };
    $g85JO.useLayoutEffect(function() {
        var el = scrollRef.current;
        if (!(el == null)) {
            var lock = restoration.lock;
            if (lock !== undefined) {
                if (!restoreFromLock(lock)) restoreFromPosition(undefined, el, restoration.position);
            } else {
                setisAutoScroll(undefined);
                restoreFromPosition(undefined, el, restoration.position);
            }
        }
    }, [
        restoration
    ]);
    var positionClassName = inline ? "" : "absolute top-0 left-0";
    var tmp = {
        ref: $5bEXW.Ref.domRef(mergedRef),
        "aria-label": "scrollable content",
        className: $1TRFX.make([
            className,
            $ezf3v.prefix(positionClassName),
            $ezf3v.prefix("w-full h-full overflow-x-hidden no-overflow-anchoring overscroll-none"),
            locked ? $ezf3v.prefix("overflow-y-hidden touch-none") : $ezf3v.prefix("overflow-y-scroll touch-pan-y")
        ]),
        role: "region",
        style: style,
        onScroll: function onScroll1(e) {
            if (stopPropagation) {
                e.preventDefault();
                e.stopPropagation();
            }
            onScroll$1(undefined);
            $iv6Yc._2(onScroll, e, isAutoScroll.current);
        }
    };
    if (onTouchEnd !== undefined) tmp.onTouchEnd = $loT9g.valFromOption(onTouchEnd);
    if (onTouchMove !== undefined) tmp.onTouchMove = $loT9g.valFromOption(onTouchMove);
    if (onTouchStart !== undefined) tmp.onTouchStart = $loT9g.valFromOption(onTouchStart);
    var tmp$1 = {
        dataTestId: "scrollable",
        children: /*#__PURE__*/ $g85JO.createElement("div", tmp, children)
    };
    if (restorationId !== undefined) tmp$1.dataId = restorationId;
    return /*#__PURE__*/ $g85JO.createElement($247f49975e2c6903$var$Scrollable$Provider, {
        children: /*#__PURE__*/ $g85JO.createElement($gCzsf.make, tmp$1),
        element: $loT9g.nullable_to_opt(scrollRef.current)
    });
}
$247f49975e2c6903$var$Scrollable.displayName = "Scrollable";
var $247f49975e2c6903$export$dd44f18ab656f3bb = $247f49975e2c6903$var$Scrollable;
 /*  Not a pure module */ 
});
parcelRegister("3tS2g", function(module, exports) {

$parcel$export(module.exports, "isDescendent", function () { return $288dfedeedc2f681$export$965a0cda204ba1d7; });
// Generated by ReScript, PLEASE EDIT WITH CARE
function $288dfedeedc2f681$export$965a0cda204ba1d7(ancestor, _descendent) {
    while(true){
        var descendent = _descendent;
        var parent = descendent.parentElement;
        if (parent == null) return false;
        if (parent === ancestor) return true;
        _descendent = parent;
        continue;
    }
}
function $288dfedeedc2f681$export$ec70bc1e11cea5ad(options, element) {
    element.scrollIntoView(options);
}
 /* No side effect */ 
});


parcelRegister("7Fi8J", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $594a6eeb7f53b35e$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $7wIsS = parcelRequire("7wIsS");

var $1xf0g = parcelRequire("1xf0g");

var $38gYA = parcelRequire("38gYA");

var $gCzsf = parcelRequire("gCzsf");

var $5bEXW = parcelRequire("5bEXW");

var $1aE5A = parcelRequire("1aE5A");

var $aSJcu = parcelRequire("aSJcu");

var $3QcL7 = parcelRequire("3QcL7");

var $9pMGg = parcelRequire("9pMGg");

var $9Whwx = parcelRequire("9Whwx");

var $8E2YL = parcelRequire("8E2YL");
function $594a6eeb7f53b35e$var$NavMenu__Sidebar$ActiveTabIndicator(Props) {
    var show = Props.show;
    var ctx = $3QcL7.use(undefined);
    var match = ctx.mode;
    var match$1 = ctx.mode;
    return /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            "absolute h-full top-0 z-0 transition motion-reduce:transition-none duration-150",
            match ? "bg-main" : "bg-transparent-to-primary",
            match$1 ? show ? "opacity-100" : "opacity-0" : show ? "opacity-5" : "opacity-0",
            ctx.mode === /* Hamburger */ 1 ? "-left-3 -right-3 border-l-2 border-accent" : "left-0 w-full"
        ]))
    });
}
$594a6eeb7f53b35e$var$NavMenu__Sidebar$ActiveTabIndicator.displayName = "NavMenu__Sidebar.ActiveTabIndicator";
var $594a6eeb7f53b35e$export$a9bd92299c9d0d8c = {
    make: $594a6eeb7f53b35e$var$NavMenu__Sidebar$ActiveTabIndicator
};
function $594a6eeb7f53b35e$var$NavMenu__Sidebar$Item(Props) {
    var index = Props.index;
    var category = Props.category;
    var link = Props.link;
    var isNestedOpt = Props.isNested;
    var isActiveOpt = Props.isActive;
    var isBoldOpt = Props.isBold;
    var isHoverDelayedOpt = Props.isHoverDelayed;
    var isNested = isNestedOpt !== undefined ? isNestedOpt : false;
    var isActive = isActiveOpt !== undefined ? isActiveOpt : false;
    var isBold = isBoldOpt !== undefined ? isBoldOpt : true;
    var isHoverDelayed = isHoverDelayedOpt !== undefined ? isHoverDelayedOpt : false;
    var ctx = $3QcL7.use(undefined);
    var match = $9pMGg.use(undefined);
    var onPureCategoryClick = match.onPureCategoryClick;
    var trackEvent = match.trackEvent;
    var match$1 = $8E2YL.use(undefined);
    var ref = $g85JO.useRef(null);
    var match$2 = ctx.mode;
    var match$3 = $1aE5A.useDelayedHover(isHoverDelayed, 50, match$2 || typeof link !== "number" ? undefined : function(param) {
        $iv6Yc._2(onPureCategoryClick, false, category);
    });
    var match$4 = $9Whwx.useTouch(true, undefined, function(e) {
        $iv6Yc._2(onPureCategoryClick, undefined, category);
    });
    var match$5 = ctx.mode;
    var handleItemTouchStart = typeof link === "number" && !match$5 ? match$4.onTouchStart : undefined;
    var match$6 = ctx.mode;
    var handleItemTouchMove = typeof link === "number" && !match$6 ? match$4.onTouchMove : undefined;
    var match$7 = ctx.mode;
    var handleItemTouchEnd = typeof link === "number" && !match$7 ? match$4.onTouchEnd : undefined;
    var handleItemClick = function handleItemClick(e) {
        var match = ctx.mode;
        if (typeof link === "number" && match) e.preventDefault();
        var match$1 = ctx.mode;
        if (typeof link === "number") {
            if (match$1) return $iv6Yc._2(onPureCategoryClick, undefined, category);
        } else if (link.TAG === /* InternalLink */ 0) return $iv6Yc._1(link._0, undefined);
        $iv6Yc.app(trackEvent, [
            "menu:link clicked",
            undefined,
            category,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined
        ]);
    };
    var href;
    href = typeof link === "number" ? $1xf0g.getCategoryLink(category) : link.TAG === /* InternalLink */ 0 ? undefined : link._0.href;
    var target;
    target = typeof link === "number" ? match$1.config.settings.openLinkInNewTab ? "_blank" : undefined : link.TAG === /* InternalLink */ 0 || !link._0.openInNewTab ? undefined : "_blank";
    var match$8 = ctx.mode;
    var match$9 = ctx.mode;
    var tmp = {
        ref: $5bEXW.Ref.domRef(ref),
        className: $ezf3v.prefix($1TRFX.make([
            "outline-none no-underline relative flex flex-row items-center group",
            isActive ? "z-2" : "z-1",
            isNested && ctx.mode === /* Hamburger */ 1 ? "pl-2" : "",
            !isNested && index !== 0 ? "mt-2" : "",
            isActive ? "text-accent" : "text-primary group-hover:text-accent",
            match$8 && !isNested ? "py-4" : "py-3",
            match$9 || link === /* NoLink */ 0 ? "" : "hover:underline"
        ])),
        tabIndex: 0,
        onClick: handleItemClick,
        onMouseLeave: match$3.onMouseLeave
    };
    if (href !== undefined) tmp.href = $loT9g.valFromOption(href);
    if (target !== undefined) tmp.target = $loT9g.valFromOption(target);
    if (match$3.onMouseEnter !== undefined) tmp.onMouseEnter = $loT9g.valFromOption(match$3.onMouseEnter);
    if (handleItemTouchEnd !== undefined) tmp.onTouchEnd = $loT9g.valFromOption(handleItemTouchEnd);
    if (handleItemTouchMove !== undefined) tmp.onTouchMove = $loT9g.valFromOption(handleItemTouchMove);
    if (handleItemTouchStart !== undefined) tmp.onTouchStart = $loT9g.valFromOption(handleItemTouchStart);
    return /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
        dataTestId: "nav-menu-sidebar-item",
        children: /*#__PURE__*/ $g85JO.createElement("li", undefined, /*#__PURE__*/ $g85JO.createElement("a", tmp, /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("flex-grow")
        }, /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix($1TRFX.make([
                "flex flex-col",
                "relative z-1",
                "truncate-lines truncate-lines-2 select-none",
                isNested ? "text-base" : "text-lg",
                !isNested && isBold ? "font-semibold" : "",
                isNested && !isActive && ctx.mode === /* Hamburger */ 1 ? "opacity-80" : ""
            ]))
        }, /*#__PURE__*/ $g85JO.createElement("div", undefined, category.title))), ctx.mode === /* Topbar */ 0 && link === /* NoLink */ 0 ? /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix($1TRFX.make([
                "flex-shrink-0 mx-4 text-accent transition-opacity duration-300",
                isActive ? "opacity-100" : "opacity-0 group-hover:opacity-100"
            ]))
        }, /*#__PURE__*/ $g85JO.createElement($7wIsS.UilAngleRightB.make, {
            size: /* Px */ {
                _0: 18
            }
        })) : null, /*#__PURE__*/ $g85JO.createElement($594a6eeb7f53b35e$var$NavMenu__Sidebar$ActiveTabIndicator, {
            show: isActive
        })))
    });
}
$594a6eeb7f53b35e$var$NavMenu__Sidebar$Item.displayName = "NavMenu__Sidebar.Item";
var $594a6eeb7f53b35e$var$make = /*#__PURE__*/ $g85JO.memo($594a6eeb7f53b35e$var$NavMenu__Sidebar$Item);
var $594a6eeb7f53b35e$export$6d08773d2e66f8f2 = {
    make: $594a6eeb7f53b35e$var$make
};
function $594a6eeb7f53b35e$var$NavMenu__Sidebar(Props) {
    var level = Props.level;
    var items = Props.items;
    var dataTestId = Props.dataTestId;
    var classNameOpt = Props.className;
    var style = Props.style;
    var className = classNameOpt !== undefined ? classNameOpt : "";
    $aSJcu.use(undefined);
    var ctx = $3QcL7.use(undefined);
    var isHoverDelayed = level > 1;
    var activeItems = $g85JO.useMemo(function() {
        return $2whNH.mapWithDefault($2whNH.keep(items, function(items) {
            return items.length !== 0;
        }), [], function(items) {
            return $i7mYY.keep(items, function(item) {
                return $i7mYY.some(ctx.currentFullPath, function(c) {
                    return c.id === item.category.id;
                });
            });
        });
    }, [
        ctx.currentFullPath
    ]);
    var getIsActive = function getIsActive(category) {
        return $2whNH.mapWithDefault($i7mYY.get(activeItems, activeItems.length - 1 | 0), false, function(item) {
            return item.category.id === category.id;
        });
    };
    return $2whNH.mapWithDefault($2whNH.keep(items, function(items) {
        return items.length > 1;
    }), null, function(items) {
        var tmp = {
            className: $1TRFX.make([
                className,
                $ezf3v.prefix("flex flex-col relative")
            ])
        };
        if (style !== undefined) tmp.style = $loT9g.valFromOption(style);
        var tmp$1 = {
            children: /*#__PURE__*/ $g85JO.createElement("ul", {
                className: $ezf3v.prefix("list-none flex-shrink-0 w-full")
            }, $i7mYY.mapWithIndex($i7mYY.keep($i7mYY.keep(items, function(item) {
                return !item.isHidden;
            }), function(item) {
                if (item.isNested) return !ctx.threeColumnLayout;
                else return true;
            }), function(index, param) {
                var category = param.category;
                return /*#__PURE__*/ $g85JO.createElement($594a6eeb7f53b35e$var$make, {
                    index: index,
                    category: category,
                    link: param.link,
                    isNested: param.isNested,
                    isActive: getIsActive(category),
                    isBold: level === 1 || index === 0,
                    isHoverDelayed: isHoverDelayed,
                    key: category.id
                });
            }))
        };
        if (dataTestId !== undefined) tmp$1.dataTestId = $loT9g.valFromOption(dataTestId);
        return /*#__PURE__*/ $g85JO.createElement("div", tmp, /*#__PURE__*/ $g85JO.createElement($38gYA.make, {
            children: /*#__PURE__*/ $g85JO.createElement($gCzsf.make, tmp$1),
            className: $ezf3v.prefix($1TRFX.make([
                "relative h-full no-scrollbar",
                ctx.mode === /* Topbar */ 0 ? "pt-6 pl-4 pb-20" : "px-3"
            ])),
            rememberScrollPosition: false
        }), ctx.mode === /* Hamburger */ 1 ? /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("absolute inset-0 bg-primary opacity-5 -z-1")
        }), /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("absolute inset-0 opacity-5 -z-1 border-r border-primary")
        })) : /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("absolute inset-0 opacity-5 -z-1 border-r border-primary")
        }));
    });
}
$594a6eeb7f53b35e$var$NavMenu__Sidebar.displayName = "NavMenu__Sidebar";
var $594a6eeb7f53b35e$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($594a6eeb7f53b35e$var$NavMenu__Sidebar);
var $594a6eeb7f53b35e$export$1fad8eb4ccf1af8f = 50;
 /* make Not a pure module */ 
});

parcelRegister("g0zNe", function(module, exports) {

$parcel$export(module.exports, "CLPSection", function () { return $ba78692997df3842$export$484919aae3bda9b; });
$parcel$export(module.exports, "make", function () { return $ba78692997df3842$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $1xf0g = parcelRequire("1xf0g");

var $i3Bxr = parcelRequire("i3Bxr");

var $1No3n = parcelRequire("1No3n");

var $3uZKH = parcelRequire("3uZKH");

var $3QcL7 = parcelRequire("3QcL7");

var $ev4rL = parcelRequire("ev4rL");

var $8YvTh = parcelRequire("8YvTh");
function $ba78692997df3842$export$8f4d5b93708d27bf(minColumns, category) {
    var columns = $i3Bxr.GridColumns.minColumns($1xf0g.Layout.getColumns(category.userSelectedLayout), $2whNH.getWithDefault(minColumns, /* OneColumnGrid */ 0));
    var gap = $1xf0g.Layout.getGap(category.userSelectedLayout);
    var maxWidth = $1xf0g.Layout.getMaxWidth(category.userSelectedLayout);
    var padding = $1xf0g.Layout.getPadding(category.userSelectedLayout);
    var maxRows = $1xf0g.Layout.getMaxRows(category.userSelectedLayout);
    return {
        columns: columns,
        gap: gap,
        maxRows: maxRows,
        maxWidth: maxWidth,
        padding: padding,
        pattern: undefined
    };
}
function $ba78692997df3842$var$NavMenu__Sections$CLPSection(Props) {
    var index = Props.index;
    var category = Props.category;
    var limitMaxRowsOpt = Props.limitMaxRows;
    var scrollableContainerRef = Props.scrollableContainerRef;
    var getForcedOpenLink = Props.getForcedOpenLink;
    var limitMaxRows = limitMaxRowsOpt !== undefined ? limitMaxRowsOpt : true;
    var ctx = $3QcL7.use(undefined);
    var isSocialNetworkContent = $2whNH.isSome(category.socialNetworkSource);
    var category$1 = $g85JO.useMemo(function() {
        return $1xf0g.setTabbedSubCategories(category, undefined);
    }, [
        category.lastModifiedAt
    ]);
    var baseLayout = $ba78692997df3842$export$8f4d5b93708d27bf(undefined, category$1);
    var layout = $g85JO.useMemo(function() {
        return {
            TAG: /* GridLayout */ 1,
            _0: {
                columns: baseLayout.columns,
                gap: baseLayout.gap,
                maxRows: limitMaxRows ? $2whNH.orElse($2whNH.keep(baseLayout.maxRows, function(maxRows) {
                    return maxRows > 1;
                }), isSocialNetworkContent ? undefined : ctx.mode === /* Hamburger */ 1 ? 2 : 1) : baseLayout.maxRows,
                maxWidth: baseLayout.maxWidth,
                padding: baseLayout.padding,
                pattern: baseLayout.pattern
            }
        };
    }, [
        category$1.lastModifiedAt
    ]);
    var link = $1No3n.useLinkFromCategory(undefined, category$1);
    var match = category$1.userSelectedLayout;
    var tmp;
    var exit = 0;
    if (typeof match === "number") tmp = /* Category */ 1;
    else switch(match.TAG | 0){
        case /* ProductGrid */ 3:
        case /* ProductSlider */ 4:
            exit = 1;
            break;
        default:
            tmp = /* Category */ 1;
    }
    if (exit === 1) {
        var match$1 = $1xf0g.ExternalConnection.getConnection(category$1);
        if (match$1 !== undefined && typeof match$1 === "number") switch(match$1){
            case /* History */ 0:
                tmp = /* History */ 3;
                break;
            case /* Favorites */ 1:
                tmp = /* Favorites */ 2;
                break;
            case /* StoreCart */ 2:
                tmp = /* StoreCart */ 4;
                break;
        }
        else tmp = /* Products */ 0;
    }
    var tmp$1;
    if (category$1.showTitle) {
        var tmp$2 = {
            path: [
                category$1
            ],
            layout: layout
        };
        if (link !== undefined) tmp$2.link = $loT9g.valFromOption(link);
        tmp$1 = /*#__PURE__*/ $g85JO.createElement($8YvTh.make, tmp$2);
    } else tmp$1 = null;
    return /*#__PURE__*/ $g85JO.createElement($3uZKH.make, {
        index: index,
        preferredContentType: tmp,
        shouldShowHeader: !isSocialNetworkContent,
        category: category$1,
        layout: layout,
        scrollableContainerRef: scrollableContainerRef,
        forcedOpenLink: getForcedOpenLink,
        enableInlineMedia: false,
        customTitle: tmp$1
    });
}
$ba78692997df3842$var$NavMenu__Sections$CLPSection.displayName = "NavMenu__Sections.CLPSection";
var $ba78692997df3842$var$make = /*#__PURE__*/ $g85JO.memo($ba78692997df3842$var$NavMenu__Sections$CLPSection);
var $ba78692997df3842$export$484919aae3bda9b = {
    make: $ba78692997df3842$var$make
};
function $ba78692997df3842$var$NavMenu__Sections$CLPQuickCategoriesSection(Props) {
    var category = Props.category;
    var path = Props.path;
    var link = Props.link;
    var scrollableContainerRef = Props.scrollableContainerRef;
    var getForcedOpenLink = Props.getForcedOpenLink;
    var layout = $g85JO.useMemo(function() {
        return {
            TAG: /* GridLayout */ 1,
            _0: $ba78692997df3842$export$8f4d5b93708d27bf(undefined, category)
        };
    }, [
        category.lastModifiedAt
    ]);
    var category$1 = $g85JO.useMemo(function() {
        return $2whNH.map($2whNH.keep($2whNH.map(category, function(category) {
            return $1xf0g.setChildren(category, $i7mYY.keep($1xf0g.getChildren(category), function(category) {
                if (category.visibleInParent) return category.visibleInHeaderSlider;
                else return false;
            }));
        }), function(category) {
            return $1xf0g.getChildren(category).length !== 0;
        }), function(__x) {
            return $1xf0g.setTabbedSubCategories(__x, undefined);
        });
    }, [
        category.lastModifiedAt,
        $i7mYY.map($1xf0g.getChildren(category), function(child) {
            return child.id;
        })
    ]);
    return $2whNH.mapWithDefault(category$1, null, function(category) {
        var tmp;
        if (category.showTitle) {
            var tmp$1 = {
                path: path,
                layout: layout
            };
            if (link !== undefined) tmp$1.link = $loT9g.valFromOption(link);
            tmp = /*#__PURE__*/ $g85JO.createElement($8YvTh.make, tmp$1);
        } else tmp = null;
        return /*#__PURE__*/ $g85JO.createElement($3uZKH.make, {
            index: 0,
            preferredContentType: /* Category */ 1,
            category: category,
            layout: layout,
            scrollableContainerRef: scrollableContainerRef,
            forcedOpenLink: getForcedOpenLink,
            enableFirstCard: false,
            customTitle: tmp
        });
    });
}
$ba78692997df3842$var$NavMenu__Sections$CLPQuickCategoriesSection.displayName = "NavMenu__Sections.CLPQuickCategoriesSection";
var $ba78692997df3842$var$make$1 = /*#__PURE__*/ $g85JO.memo($ba78692997df3842$var$NavMenu__Sections$CLPQuickCategoriesSection);
var $ba78692997df3842$export$1b0b0e575e1b7dd0 = {
    make: $ba78692997df3842$var$make$1
};
function $ba78692997df3842$var$NavMenu__Sections(Props) {
    var allowQuickCategoriesOpt = Props.allowQuickCategories;
    var allCategories = Props.allCategories;
    var category = Props.category;
    var scrollableContainerRef = Props.scrollableContainerRef;
    var allowQuickCategories = allowQuickCategoriesOpt !== undefined ? allowQuickCategoriesOpt : true;
    var path = $g85JO.useMemo(function() {
        return $1xf0g.getCategoryPathById(allCategories, category.id);
    }, [
        allCategories,
        category.id
    ]);
    var link = $1No3n.useLinkFromCategory(undefined, category);
    var ctx = $3QcL7.use(undefined);
    var getForcedOpenLink = $g85JO.useCallback(function(category) {
        var categoryPath = $1xf0g.getCategoryPathById(allCategories, category.id);
        if (categoryPath.length > ctx.maxLevels) return /* ForceAllCards */ 0;
        else return /* ForceLastCards */ 2;
    }, [
        allCategories
    ]);
    var isDeadend = $1xf0g.getChildren(category).length === 0;
    return /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("flex flex-col pt-8 space-y-row-custom")
    }, isDeadend ? /*#__PURE__*/ $g85JO.createElement($ev4rL.make, {
        category: category,
        path: path,
        link: link,
        scrollableContainerRef: scrollableContainerRef,
        getForcedOpenLink: getForcedOpenLink
    }) : /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, allowQuickCategories ? /*#__PURE__*/ $g85JO.createElement($ba78692997df3842$var$make$1, {
        category: category,
        path: path,
        link: link,
        scrollableContainerRef: scrollableContainerRef,
        getForcedOpenLink: getForcedOpenLink
    }) : null, $i7mYY.mapWithIndex($i7mYY.keep($1xf0g.getChildren(category), function(category) {
        return category.visibleInSectionList;
    }), function(index, category) {
        return /*#__PURE__*/ $g85JO.createElement($ba78692997df3842$var$make, {
            index: index + 1 | 0,
            category: category,
            scrollableContainerRef: scrollableContainerRef,
            getForcedOpenLink: getForcedOpenLink,
            key: category.id
        });
    })));
}
$ba78692997df3842$var$NavMenu__Sections.displayName = "NavMenu__Sections";
var $ba78692997df3842$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($ba78692997df3842$var$NavMenu__Sections);
 /* make Not a pure module */ 
});
parcelRegister("1No3n", function(module, exports) {

$parcel$export(module.exports, "useLinkFromCategory", function () { return $14ed06924e5ddc87$export$2424dbd8b6dc0037; });
$parcel$export(module.exports, "make", function () { return $14ed06924e5ddc87$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $7wIsS = parcelRequire("7wIsS");

var $1xf0g = parcelRequire("1xf0g");

var $3QcL7 = parcelRequire("3QcL7");

var $9pMGg = parcelRequire("9pMGg");

var $8E2YL = parcelRequire("8E2YL");
function $14ed06924e5ddc87$export$2424dbd8b6dc0037(labelFormatOpt, category) {
    var labelFormat = labelFormatOpt !== undefined ? labelFormatOpt : [
        /* GenericCTA */ 0,
        /* ProductCount */ 2
    ];
    var match = $8E2YL.use(undefined);
    var match$1 = match.config.settings;
    var openLinkInNewTab = match$1.openLinkInNewTab;
    var openLinkLabel = match$1.openLinkLabel;
    var match$2 = $2whNH.flatMap(category, $1xf0g.ExternalConnection.getStoreCategoryConnection);
    var count;
    if (match$2 !== undefined) {
        var count$1 = match$2.count;
        count = count$1 > 0 ? "(" + count$1.toString() + ")" : undefined;
    } else count = undefined;
    var label = $i7mYY.keepMap($i7mYY.map(labelFormat, function(part) {
        switch(part){
            case /* GenericCTA */ 0:
                return openLinkLabel;
            case /* CategoryTitle */ 1:
                return $2whNH.map(category, function(category) {
                    return category.title;
                });
            case /* ProductCount */ 2:
                return count;
        }
    }), function(a) {
        return a;
    }).join(" ");
    return $g85JO.useMemo(function() {
        if (category !== undefined) return $2whNH.flatMap($1xf0g.Link.getCardFallbackLink(category), function(link) {
            if (link.TAG === /* URL */ 0) return {
                href: link._0,
                label: label,
                openInNewTab: openLinkInNewTab,
                category: category
            };
        });
    }, [
        $2whNH.map(category, function(category) {
            return category.lastModifiedAt;
        })
    ]);
}
function $14ed06924e5ddc87$var$NavMenu__Link(Props) {
    var link = Props.link;
    var classNameOpt = Props.className;
    var className = classNameOpt !== undefined ? classNameOpt : "";
    var match = $9pMGg.use(undefined);
    var trackEvent = match.trackEvent;
    var ctx = $3QcL7.use(undefined);
    var handleClick = function handleClick(e) {
        $iv6Yc.app(trackEvent, [
            "menu:link clicked",
            true,
            link.category,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined
        ]);
    };
    var match$1 = ctx.mode;
    var tmp = {
        className: $1TRFX.make([
            className,
            $ezf3v.prefix("inline-flex relative text-secondary no-underline hover:underline"),
            match$1 ? $ezf3v.prefix("text-base whitespace-nowrap px-2 py-1") : $ezf3v.prefix("text-lg")
        ]),
        href: link.href,
        onClick: handleClick
    };
    var tmp$1 = link.openInNewTab ? "_blank" : undefined;
    if (tmp$1 !== undefined) tmp.target = $loT9g.valFromOption(tmp$1);
    return /*#__PURE__*/ $g85JO.createElement("a", tmp, /*#__PURE__*/ $g85JO.createElement("div", undefined, link.label), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("ml-1 -mr-1 flex items-center")
    }, /*#__PURE__*/ $g85JO.createElement($7wIsS.UilAngleRightB.make, {
        size: /* Px */ {
            _0: 16
        }
    })));
}
$14ed06924e5ddc87$var$NavMenu__Link.displayName = "NavMenu__Link";
var $14ed06924e5ddc87$export$dd44f18ab656f3bb = $14ed06924e5ddc87$var$NavMenu__Link;
 /* react Not a pure module */ 
});

parcelRegister("ev4rL", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $a8e768f803ff20c5$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $1xf0g = parcelRequire("1xf0g");

var $hBcYV = parcelRequire("hBcYV");

var $3uZKH = parcelRequire("3uZKH");

var $aSJcu = parcelRequire("aSJcu");

var $3QcL7 = parcelRequire("3QcL7");

var $9pMGg = parcelRequire("9pMGg");

var $v7lDW = parcelRequire("v7lDW");

var $8YvTh = parcelRequire("8YvTh");

var $8E2YL = parcelRequire("8E2YL");

var $hYM4T = parcelRequire("hYM4T");
function $a8e768f803ff20c5$var$NavMenu__PLPContent(Props) {
    var category = Props.category;
    var path = Props.path;
    var link = Props.link;
    var scrollableContainerRef = Props.scrollableContainerRef;
    var ctx = $3QcL7.use(undefined);
    var match = $aSJcu.use(undefined);
    var match$1 = $8E2YL.use(undefined);
    var match$2 = $9pMGg.use(undefined);
    var toggleFiltersPanel = match$2.toggleFiltersPanel;
    var match$3 = $hBcYV.useRouter(undefined);
    var isFullPLPEnabled = match.isMobile && match$1.config.settings.filtersEnabled;
    var layout = $g85JO.useMemo(function() {
        return {
            TAG: /* GridLayout */ 1,
            _0: {
                columns: $1xf0g.Layout.getColumns(category.listPageActiveLayout),
                gap: $1xf0g.Layout.getGap(category.listPageActiveLayout),
                maxRows: isFullPLPEnabled ? undefined : $2whNH.orElse($2whNH.keep($1xf0g.Layout.getMaxRows(category.userSelectedLayout), function(maxRows) {
                    return maxRows > 2;
                }), 2),
                maxWidth: undefined,
                padding: undefined,
                pattern: undefined
            }
        };
    }, [
        category.listPageActiveLayout,
        category.userSelectedLayout,
        isFullPLPEnabled
    ]);
    var match$4 = $1xf0g.ExternalConnection.getConnection(category);
    var tmp;
    if (match$4 !== undefined && typeof match$4 === "number") switch(match$4){
        case /* History */ 0:
            tmp = /* History */ 3;
            break;
        case /* Favorites */ 1:
            tmp = /* Favorites */ 2;
            break;
        case /* StoreCart */ 2:
            tmp = /* StoreCart */ 4;
            break;
    }
    else tmp = /* Products */ 0;
    var tmp$1 = {
        path: path,
        layout: layout,
        className: $ezf3v.prefix("sticky top-0 -mt-8 -mb-4 pt-8 pb-6 z-10 bg-main")
    };
    if (link !== undefined) tmp$1.link = $loT9g.valFromOption(link);
    var match$5 = $1xf0g.ExternalConnection.getStoreCategoryConnection(category);
    return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("relative z-0")
    }, /*#__PURE__*/ $g85JO.createElement($3uZKH.make, {
        index: 1,
        preferredContentType: tmp,
        category: category,
        layout: layout,
        scrollableContainerRef: scrollableContainerRef,
        forcedOpenLink: function forcedOpenLink(param) {
            return /* ForceAllCards */ 0;
        },
        enableFirstCard: false,
        enableInlineMedia: true,
        customTitle: /*#__PURE__*/ $g85JO.createElement($8YvTh.make, tmp$1)
    })), isFullPLPEnabled && match$5 !== undefined ? /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement($hYM4T.make, {
        position: "sticky",
        onClick: function onClick(param) {
            $iv6Yc._1(toggleFiltersPanel, undefined);
        }
    }), /*#__PURE__*/ $g85JO.createElement($v7lDW.make, {
        connection: match$5,
        panelSize: /* FullWidth */ 3,
        isOpen: match$2.isMobileFiltersOpen,
        fullscreen: true,
        enabledSort: true,
        appliedFilters: match$3.productFilters,
        appliedSort: match$3.productSort,
        zIndex: ctx.zIndex
    })) : null);
}
$a8e768f803ff20c5$var$NavMenu__PLPContent.displayName = "NavMenu__PLPContent";
var $a8e768f803ff20c5$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($a8e768f803ff20c5$var$NavMenu__PLPContent);
 /* make Not a pure module */ 
});
parcelRegister("v7lDW", function(module, exports) {

$parcel$export(module.exports, "preload", function () { return $05d8988abe0a4403$export$513ccb98c53b8039; });
$parcel$export(module.exports, "make", function () { return $05d8988abe0a4403$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $loT9g = parcelRequire("loT9g");

var $g85JO = parcelRequire("g85JO");

var $7tAuM = parcelRequire("7tAuM");

var $05d8988abe0a4403$var$component = (0, $7tAuM.default)(function() {
    return (parcelRequire("kxypM"));
});
function $05d8988abe0a4403$var$FiltersPanel_Lazy(Props) {
    var spacerDivOpt = Props.spacerDiv;
    var childrenOpt = Props.children;
    if (spacerDivOpt !== undefined) $loT9g.valFromOption(spacerDivOpt);
    if (childrenOpt !== undefined) $loT9g.valFromOption(childrenOpt);
    return /*#__PURE__*/ $g85JO.createElement($05d8988abe0a4403$var$component, Props);
}
$05d8988abe0a4403$var$FiltersPanel_Lazy.displayName = "FiltersPanel_Lazy";
var $05d8988abe0a4403$export$513ccb98c53b8039 = $05d8988abe0a4403$var$component.preload;
var $05d8988abe0a4403$export$dd44f18ab656f3bb = $05d8988abe0a4403$var$FiltersPanel_Lazy;
 /*  Not a pure module */ 
});
parcelRegister("kxypM", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("gORIA")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("eybsM"))
]).then(function() {
    return parcelRequire("4e7E6");
});

});


parcelRegister("8YvTh", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $688caa297e5ce58d$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $1No3n = parcelRequire("1No3n");

var $3QcL7 = parcelRequire("3QcL7");

var $9pMGg = parcelRequire("9pMGg");
function $688caa297e5ce58d$var$NavMenu__Breadcrumbs$Item(Props) {
    var category = Props.category;
    var index = Props.index;
    var path = Props.path;
    var match = $9pMGg.use(undefined);
    var onPureCategoryClick = match.onPureCategoryClick;
    var isLast = (index + 1 | 0) === path.length;
    var isFirst = index === 0;
    var handleClick = isLast ? undefined : function handleClick(param) {
        $iv6Yc._2(onPureCategoryClick, undefined, category);
    };
    var tmp = {
        className: $ezf3v.prefix($1TRFX.make([
            "flex text-primary",
            isLast ? "opacity-100" : "opacity-50 hover:opacity-75 cursor-pointer select-none"
        ]))
    };
    if (handleClick !== undefined) tmp.onClick = $loT9g.valFromOption(handleClick);
    return /*#__PURE__*/ $g85JO.createElement("div", tmp, isFirst ? null : /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("px-2")
    }, "/"), category.title);
}
$688caa297e5ce58d$var$NavMenu__Breadcrumbs$Item.displayName = "NavMenu__Breadcrumbs.Item";
var $688caa297e5ce58d$export$6d08773d2e66f8f2 = {
    make: $688caa297e5ce58d$var$NavMenu__Breadcrumbs$Item
};
function $688caa297e5ce58d$var$NavMenu__Breadcrumbs(Props) {
    var path = Props.path;
    var layout = Props.layout;
    var link = Props.link;
    var classNameOpt = Props.className;
    var className = classNameOpt !== undefined ? classNameOpt : "";
    var ctx = $3QcL7.use(undefined);
    var padding;
    padding = layout.TAG === /* SliderLayout */ 0 ? layout._0.padding : layout._0.padding;
    var maxWidth;
    maxWidth = layout.TAG === /* SliderLayout */ 0 ? layout._0.maxWidth : layout._0.maxWidth;
    var match = ctx.mode;
    var paddingXCn = padding !== undefined ? "" : match ? "px-4" : "px-8";
    var tmp = {
        maxWidth: $2whNH.mapWithDefault(maxWidth, "100%", $ezf3v.intToPx)
    };
    var tmp$1 = $2whNH.map(padding, $ezf3v.intToPx);
    if (tmp$1 !== undefined) tmp.paddingRight = tmp$1;
    var tmp$2 = $2whNH.map(padding, $ezf3v.intToPx);
    if (tmp$2 !== undefined) tmp.paddingLeft = tmp$2;
    var style = tmp;
    var match$1 = ctx.mode;
    return /*#__PURE__*/ $g85JO.createElement("div", {
        className: $1TRFX.make([
            className,
            $ezf3v.prefix(paddingXCn),
            $ezf3v.prefix("flex items-center mx-auto pb-2")
        ]),
        style: style
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            "flex items-center font-medium",
            ctx.mode === /* Topbar */ 0 ? "text-2xl" : "text-xl flex-grow"
        ]))
    }, match$1 ? $2whNH.getWithDefault($2whNH.map($i7mYY.get(path, path.length - 1 | 0), function(category) {
        return /*#__PURE__*/ $g85JO.createElement($688caa297e5ce58d$var$NavMenu__Breadcrumbs$Item, {
            category: category,
            index: 0,
            path: [
                category
            ],
            key: category.id
        });
    }), null) : $i7mYY.mapWithIndex(path, function(i, category) {
        return /*#__PURE__*/ $g85JO.createElement($688caa297e5ce58d$var$NavMenu__Breadcrumbs$Item, {
            category: category,
            index: i,
            path: path,
            key: category.id
        });
    })), $2whNH.mapWithDefault(link, null, function(link) {
        return /*#__PURE__*/ $g85JO.createElement($1No3n.make, {
            link: link,
            className: $ezf3v.prefix($1TRFX.make([
                ctx.mode === /* Topbar */ 0 ? "ml-6" : "ml-2"
            ]))
        });
    }));
}
$688caa297e5ce58d$var$NavMenu__Breadcrumbs.displayName = "NavMenu__Breadcrumbs";
var $688caa297e5ce58d$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($688caa297e5ce58d$var$NavMenu__Breadcrumbs);
 /* make Not a pure module */ 
});



parcelRegister("jsBjX", function(module, exports) {

$parcel$export(module.exports, "Container", function () { return $e2ad950206d651bf$export$42a852a2b6b56249; });
$parcel$export(module.exports, "Content", function () { return $e2ad950206d651bf$export$7c6e2c02157bb7d2; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $gCzsf = parcelRequire("gCzsf");

var $3QcL7 = parcelRequire("3QcL7");

var $kJfD2 = parcelRequire("kJfD2");
var $e2ad950206d651bf$var$context = /*#__PURE__*/ $g85JO.createContext({
    activeValue: 0,
    animate: true,
    disabled: false,
    direction: /* Vertical */ 0
});
var $e2ad950206d651bf$var$provider = $e2ad950206d651bf$var$context.Provider;
function $e2ad950206d651bf$var$useContainer(param) {
    return $g85JO.useContext($e2ad950206d651bf$var$context);
}
var $e2ad950206d651bf$export$af31ad6d6691ca2f = {
    context: $e2ad950206d651bf$var$context,
    provider: $e2ad950206d651bf$var$provider,
    useContainer: $e2ad950206d651bf$var$useContainer
};
var $e2ad950206d651bf$var$context$1 = /*#__PURE__*/ $g85JO.createContext({
    value: 0,
    disabled: false
});
var $e2ad950206d651bf$var$provider$1 = $e2ad950206d651bf$var$context$1.Provider;
function $e2ad950206d651bf$var$useContent(param) {
    return $g85JO.useContext($e2ad950206d651bf$var$context$1);
}
var $e2ad950206d651bf$export$1cbdd774077931b4 = {
    context: $e2ad950206d651bf$var$context$1,
    provider: $e2ad950206d651bf$var$provider$1,
    useContent: $e2ad950206d651bf$var$useContent
};
function $e2ad950206d651bf$var$NavMenu__Transition$Container(Props) {
    var value = Props.value;
    var direction = Props.direction;
    var animateOpt = Props.animate;
    var disabledOpt = Props.disabled;
    var children = Props.children;
    var animate = animateOpt !== undefined ? animateOpt : true;
    var disabled = disabledOpt !== undefined ? disabledOpt : false;
    var match = $g85JO.useContext($e2ad950206d651bf$var$context);
    var match$1 = $g85JO.useContext($e2ad950206d651bf$var$context$1);
    var disabled$1 = disabled || match.disabled || match$1.disabled;
    return /*#__PURE__*/ $g85JO.createElement($e2ad950206d651bf$var$provider, {
        value: {
            activeValue: value,
            animate: animate,
            disabled: disabled$1,
            direction: direction
        },
        children: children
    });
}
$e2ad950206d651bf$var$NavMenu__Transition$Container.displayName = "NavMenu__Transition.Container";
var $e2ad950206d651bf$export$42a852a2b6b56249 = {
    make: $e2ad950206d651bf$var$NavMenu__Transition$Container
};
function $e2ad950206d651bf$var$NavMenu__Transition$Content(Props) {
    var value = Props.value;
    var style = Props.style;
    var dataTestId = Props.dataTestId;
    var className = Props.className;
    var children = Props.children;
    var fwdRef = Props.fwdRef;
    var match = $g85JO.useContext($e2ad950206d651bf$var$context);
    var disabled = match.disabled;
    var animate = match.animate;
    var activeValue = match.activeValue;
    var ctx = $3QcL7.use(undefined);
    var isActive = value === activeValue && !disabled;
    var isActiveDelayed = $kJfD2.useDelayedBoolean(ctx.pageFlipTransitionSpeedMs, /* DelayFalse */ 1, isActive);
    var shouldRender = isActive || isActiveDelayed;
    var style$1 = $g85JO.useMemo(function() {
        var tmp = {};
        var tmp$1 = animate ? $ezf3v.intToMs(ctx.pageFlipTransitionSpeedMs) : undefined;
        if (tmp$1 !== undefined) tmp.transitionDuration = tmp$1;
        var tmp$2 = animate ? "transform,opacity" : undefined;
        if (tmp$2 !== undefined) tmp.transitionProperty = tmp$2;
        var defaultStyle = tmp;
        if (style !== undefined) return Object.assign({}, defaultStyle, $loT9g.valFromOption(style));
        else return defaultStyle;
    }, [
        style
    ]);
    var tmp;
    switch(match.direction){
        case /* Vertical */ 0:
            tmp = value === activeValue ? "translate-y-0" : value > activeValue ? "translate-y-7" : value < activeValue ? "-translate-y-7" : "";
            break;
        case /* Horizontal */ 1:
            tmp = value === activeValue ? "translate-x-0" : value > activeValue ? "translate-x-7" : value < activeValue ? "-translate-x-7" : "";
            break;
        case /* NoMotion */ 2:
            tmp = "";
            break;
    }
    var tmp$1 = {
        className: $1TRFX.make([
            $ezf3v.prefix($1TRFX.make([
                isActive ? "opacity-100" : "opacity-0 pointer-events-none",
                tmp,
                isActive ? "relative" : "absolute h-full",
                "top-0 left-0 w-full transform-gpu motion-reduce:transform-none ease-linear-out-slow-in"
            ])),
            $2whNH.getWithDefault(className, "")
        ]),
        style: style$1
    };
    if (fwdRef !== undefined) tmp$1.ref = $loT9g.valFromOption(fwdRef);
    var tmp$2 = isActive ? undefined : -1;
    if (tmp$2 !== undefined) tmp$1.tabIndex = $loT9g.valFromOption(tmp$2);
    var tmp$3 = {
        dataActive: isActive,
        children: /*#__PURE__*/ $g85JO.createElement("div", tmp$1, shouldRender ? children : null)
    };
    if (dataTestId !== undefined) tmp$3.dataTestId = $loT9g.valFromOption(dataTestId);
    var children$1 = /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement($gCzsf.make, tmp$3));
    return /*#__PURE__*/ $g85JO.createElement($e2ad950206d651bf$var$provider$1, {
        value: {
            value: value,
            disabled: disabled
        },
        children: children$1
    });
}
$e2ad950206d651bf$var$NavMenu__Transition$Content.displayName = "NavMenu__Transition.Content";
var $e2ad950206d651bf$export$7c6e2c02157bb7d2 = {
    make: $e2ad950206d651bf$var$NavMenu__Transition$Content
};
 /* context Not a pure module */ 
});
parcelRegister("kJfD2", function(module, exports) {

$parcel$export(module.exports, "useDelayedBoolean", function () { return $f1742224f3edabf7$export$1d49af484e5ac1a6; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");
function $f1742224f3edabf7$export$1d49af484e5ac1a6(delay, mode, input) {
    var match = $g85JO.useState(function() {
        return input;
    });
    var setResult = match[1];
    var timeoutId = $g85JO.useRef(undefined);
    var $$clearTimeout$1 = function $$clearTimeout$1(param) {
        $2whNH.forEach(timeoutId.current, function(prim) {
            clearTimeout(prim);
        });
    };
    $g85JO.useEffect(function() {
        return $$clearTimeout$1;
    }, []);
    $g85JO.useEffect(function() {
        var shouldDelay;
        switch(mode){
            case /* DelayTruth */ 0:
                shouldDelay = input;
                break;
            case /* DelayFalse */ 1:
                shouldDelay = !input;
                break;
            case /* DelayBoth */ 2:
                shouldDelay = true;
                break;
        }
        if (shouldDelay) timeoutId.current = $loT9g.some(setTimeout(function(param) {
            $iv6Yc._1(setResult, function(param) {
                return input;
            });
        }, delay));
        else {
            $$clearTimeout$1(undefined);
            $iv6Yc._1(setResult, function(param) {
                return input;
            });
        }
    }, [
        input
    ]);
    return match[0];
}
 /* react Not a pure module */ 
});



parcelRegister("87Cf3", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $5e9ca42dbbb1c74d$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $ezf3v = parcelRequire("ezf3v");

var $1xf0g = parcelRequire("1xf0g");

var $38gYA = parcelRequire("38gYA");

var $g0zNe = parcelRequire("g0zNe");

var $8E2YL = parcelRequire("8E2YL");
function $5e9ca42dbbb1c74d$var$NavMenu__IndexContent(Props) {
    var category = Props.category;
    var match = $8E2YL.use(undefined);
    var config = match.config;
    var scrollableContainerRef = $g85JO.useRef(null);
    var category$1 = $g85JO.useMemo(function() {
        var newrecord = $7bjme.obj_dup(category);
        var rest = category.categoryType;
        var tmp;
        tmp = typeof rest === "number" || rest.TAG !== /* Index */ 3 ? rest : {
            TAG: /* Standard */ 1,
            _0: {
                firstCard: undefined,
                externalConnection: rest._0.externalConnection,
                children: $i7mYY.keep(config.categories, function(category) {
                    return !$1xf0g.isIndexNode(category);
                }),
                loadMoreChildren: undefined,
                totalChildren: 0,
                link: undefined,
                products: [],
                taggedMedia: undefined,
                imageHotspots: undefined,
                imageWidth: undefined,
                imageHeight: undefined
            }
        };
        newrecord.categoryType = tmp;
        var match = category.userSelectedLayout;
        var tmp$1;
        if (typeof match === "number") tmp$1 = /* NoLayout */ 0;
        else switch(match.TAG | 0){
            case /* SubCategoriesGrid */ 2:
            case /* ProductGrid */ 3:
                tmp$1 = {
                    TAG: /* SubCategoriesGrid */ 2,
                    _0: match._0
                };
                break;
            default:
                tmp$1 = {
                    TAG: /* SubCategoriesSlider */ 0,
                    _0: match._0
                };
        }
        newrecord.userSelectedLayout = tmp$1;
        newrecord.showTitle = true;
        newrecord.title = "";
        return newrecord;
    }, [
        category.id,
        config.lastModifiedAt
    ]);
    var match$1 = category$1.userSelectedLayout;
    var tmp;
    var exit = 0;
    if (typeof match$1 === "number" || match$1.TAG !== /* SubCategoriesGrid */ 2) exit = 1;
    else tmp = /*#__PURE__*/ $g85JO.createElement($g0zNe.CLPSection.make, {
        index: 0,
        category: category$1,
        limitMaxRows: false,
        scrollableContainerRef: scrollableContainerRef,
        getForcedOpenLink: function getForcedOpenLink(param) {
            return /* ForceNoCards */ 3;
        }
    });
    if (exit === 1) tmp = /*#__PURE__*/ $g85JO.createElement($g0zNe.make, {
        allowQuickCategories: false,
        allCategories: config.categories,
        category: category$1,
        scrollableContainerRef: scrollableContainerRef
    });
    return /*#__PURE__*/ $g85JO.createElement($38gYA.make, {
        restorationId: "nav-menu-sections-" + category$1.id + "",
        children: tmp,
        fwdRef: scrollableContainerRef,
        className: $ezf3v.prefix("relative h-full no-scrollbar pb-20"),
        rememberScrollPosition: false
    });
}
$5e9ca42dbbb1c74d$var$NavMenu__IndexContent.displayName = "NavMenu__IndexContent";
var $5e9ca42dbbb1c74d$export$dd44f18ab656f3bb = $5e9ca42dbbb1c74d$var$NavMenu__IndexContent;
 /* react Not a pure module */ 
});

parcelRegister("b8WNX", function(module, exports) {

$parcel$export(module.exports, "preload", function () { return $81ce0e7d77235b59$export$513ccb98c53b8039; });
$parcel$export(module.exports, "make", function () { return $81ce0e7d77235b59$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7tAuM = parcelRequire("7tAuM");

var $81ce0e7d77235b59$var$component = (0, $7tAuM.default)(function() {
    return (parcelRequire("lSt1Q"));
});
function $81ce0e7d77235b59$var$QuickViewOverlay_Lazy(Props) {
    return /*#__PURE__*/ $g85JO.createElement($81ce0e7d77235b59$var$component, Props);
}
$81ce0e7d77235b59$var$QuickViewOverlay_Lazy.displayName = "QuickViewOverlay_Lazy";
var $81ce0e7d77235b59$export$513ccb98c53b8039 = $81ce0e7d77235b59$var$component.preload;
var $81ce0e7d77235b59$export$dd44f18ab656f3bb = $81ce0e7d77235b59$var$QuickViewOverlay_Lazy;
 /*  Not a pure module */ 
});
parcelRegister("lSt1Q", function(module, exports) {












module.exports = Promise.all([
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("67jxL")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("cYw4f")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("6zo4Z")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("5PtUs")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("bumwY")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("3pqCl"))
]).then(function() {
    return parcelRequire("1xMeg");
});

});


parcelRegister("iWHC4", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $dcaf7970ba2d3988$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $81N94 = parcelRequire("81N94");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $9Skhv = parcelRequire("9Skhv");

var $avqDR = parcelRequire("avqDR");

var $cTjaa = parcelRequire("cTjaa");

var $aSJcu = parcelRequire("aSJcu");

var $3QcL7 = parcelRequire("3QcL7");

var $9pMGg = parcelRequire("9pMGg");

var $jLIqo = parcelRequire("jLIqo");

var $kJfD2 = parcelRequire("kJfD2");

var $hv3Nv = parcelRequire("hv3Nv");

var $c2FOD = parcelRequire("c2FOD");

var $8E2YL = parcelRequire("8E2YL");

var $gUsPc = parcelRequire("gUsPc");
function $dcaf7970ba2d3988$export$22dde8c9f91fba61(activeValue, param) {
    var ctx = $3QcL7.use(undefined);
    var match = $8E2YL.use(undefined);
    var match$1 = match.config;
    var match$2 = $aSJcu.use(undefined);
    var windowHeight = match$2.windowSize.height;
    $9Skhv.useWindow(undefined, undefined);
    var match$3 = $gUsPc.use(undefined);
    var siteHeaderCSSSelector = $avqDR.getSiteHeaderCSSSelector(match$1.settings, match$1.transitiveAccount);
    var siteHeaderRef = $hv3Nv.use(undefined, siteHeaderCSSSelector);
    var siteHeaderSize = $cTjaa.useResizeObserver(undefined, siteHeaderRef);
    var embedSize = $cTjaa.useResizeObserver(undefined, match$3.containerRef);
    var siteHeaderSize$1 = $2whNH.getWithDefault($2whNH.orElse(siteHeaderSize, embedSize), $cTjaa.empty);
    var match$4 = ctx.mode;
    var modalTop = match$4 ? 0 : $81N94.int_max(0, siteHeaderSize$1.height + siteHeaderSize$1.top | 0);
    var modalBackdropHeight = windowHeight > 768 ? ctx.modalBackdropHeight : ctx.modalBackdropHeight / 2 | 0;
    var match$5 = ctx.mode;
    var modalMaxHeight = match$5 ? windowHeight : $81N94.int_min(windowHeight - modalBackdropHeight | 0, windowHeight - ((siteHeaderSize$1.height + siteHeaderSize$1.top | 0) + modalBackdropHeight | 0) | 0);
    return {
        modalTop: modalTop,
        modalMaxHeight: modalMaxHeight,
        siteHeaderSize: siteHeaderSize$1
    };
}
function $dcaf7970ba2d3988$export$e3706872b03320ba(param) {
    var ctx = $3QcL7.use(undefined);
    var match = $9pMGg.use(undefined);
    var trackEvent = match.trackEvent;
    var openEventTriggered = $g85JO.useRef(false);
    $g85JO.useEffect(function() {
        var match = ctx.isModalOpen;
        var match$1 = openEventTriggered.current;
        if (match && !match$1) {
            $iv6Yc.app(trackEvent, [
                "open",
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined
            ]);
            $iv6Yc.app(trackEvent, [
                "menu:open",
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined
            ]);
            openEventTriggered.current = true;
        }
    }, [
        ctx.isModalOpen
    ]);
}
function $dcaf7970ba2d3988$var$NavMenu__ModalContainer(Props) {
    var activeValue = Props.activeValue;
    var children = Props.children;
    var onMouseLeave = Props.onMouseLeave;
    var onMouseEnter = Props.onMouseEnter;
    var ctx = $3QcL7.use(undefined);
    var viewport = $aSJcu.use(undefined);
    $8E2YL.use(undefined);
    var mounted = $kJfD2.useDelayedBoolean(ctx.modalTransitionSpeedMs, /* DelayFalse */ 1, ctx.isModalOpen);
    var positions = $dcaf7970ba2d3988$export$22dde8c9f91fba61(activeValue, undefined);
    $dcaf7970ba2d3988$export$e3706872b03320ba(undefined);
    var renderHorizontalBorder = function renderHorizontalBorder(param) {
        return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("absolute pointer-events-none z-20 left-0 w-full border-t border-primary opacity-10")
        }), /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("absolute pointer-events-none bottom-0 left-0 w-full border-b border-primary opacity-10")
        }));
    };
    var match = ctx.mode;
    var updatedViewport = match ? {
        isMobile: viewport.isMobile,
        breakpoint: viewport.breakpoint,
        windowSize: {
            width: Math.min(ctx.modalMaxWidth, viewport.windowSize.width),
            height: viewport.windowSize.height
        }
    } : viewport;
    var match$1 = ctx.mode;
    var match$2 = ctx.mode;
    var match$3 = ctx.mode;
    var tmp = {
        className: $ezf3v.prefix($1TRFX.make([
            mounted ? "" : "hidden",
            "fixed",
            "transition animate-enter-scaleup motion-reduce:animate-enter-fadein",
            "left-0 w-full",
            "transform motion-reduce:transform-none",
            ctx.isModalOpen ? "scale-100 opacity-100 ease-linear-out-slow-in" : "scale-95 opacity-0 ease-fast-out-linear-in",
            "bg-main text-primary",
            match$1 ? "top-0 h-full" : ""
        ])),
        style: {
            maxHeight: $ezf3v.intToPx(positions.modalMaxHeight),
            maxWidth: match$2 ? $ezf3v.intToPx(ctx.modalMaxWidth) : "100%",
            top: $ezf3v.intToPx(positions.modalTop),
            zIndex: String(ctx.zIndex),
            animationDuration: $ezf3v.intToMs(ctx.modalTransitionSpeedMs),
            transitionDuration: $ezf3v.intToMs(ctx.modalTransitionSpeedMs),
            transformOrigin: match$3 ? "center left" : "top center",
            pointerEvents: ctx.isModalOpen ? "auto" : "none"
        }
    };
    if (onMouseEnter !== undefined) tmp.onMouseEnter = $loT9g.valFromOption(onMouseEnter);
    if (onMouseLeave !== undefined) tmp.onMouseLeave = $loT9g.valFromOption(onMouseLeave);
    return /*#__PURE__*/ $g85JO.createElement($3QcL7.Provider.make, {
        value: {
            mode: ctx.mode,
            currentFullPath: ctx.currentFullPath,
            currentL1: ctx.currentL1,
            currentL2: ctx.currentL2,
            currentL3: ctx.currentL3,
            pageFlipTransitionSpeedMs: ctx.pageFlipTransitionSpeedMs,
            modalTransitionSpeedMs: ctx.modalTransitionSpeedMs,
            modalBackdropHeight: ctx.modalBackdropHeight,
            modalBackdropOpacity: ctx.modalBackdropOpacity,
            modalMaxWidth: ctx.modalMaxWidth,
            zIndex: ctx.zIndex,
            maxLevels: ctx.maxLevels,
            positions: positions,
            threeColumnLayout: ctx.threeColumnLayout,
            isModalOpen: ctx.isModalOpen,
            isIndexAllowed: ctx.isIndexAllowed
        },
        children: null
    }, /*#__PURE__*/ $g85JO.createElement($jLIqo.make, {}), /*#__PURE__*/ $g85JO.createElement("div", tmp, renderHorizontalBorder(undefined), /*#__PURE__*/ $g85JO.createElement($aSJcu.Provider.make, {
        value: updatedViewport,
        children: /*#__PURE__*/ $g85JO.createElement($c2FOD.make, {
            children: children
        })
    })));
}
$dcaf7970ba2d3988$var$NavMenu__ModalContainer.displayName = "NavMenu__ModalContainer";
var $dcaf7970ba2d3988$export$dd44f18ab656f3bb = $dcaf7970ba2d3988$var$NavMenu__ModalContainer;
 /* react Not a pure module */ 
});
parcelRegister("9Skhv", function(module, exports) {

$parcel$export(module.exports, "useWindow", function () { return $7308e3a60dc0d422$export$24b8fbafc4b6a151; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $ePG8R = parcelRequire("ePG8R");

var $7GW0c = parcelRequire("7GW0c");
function $7308e3a60dc0d422$export$24b8fbafc4b6a151(enabledOpt, param) {
    var enabled = enabledOpt !== undefined ? enabledOpt : true;
    var match = $ePG8R.use(30, true, function(param) {
        return $iv6Yc._1($7GW0c.$$Window.scrollY, undefined);
    });
    var setScrollPosition = match[1];
    var onScroll = function onScroll(e) {
        $iv6Yc._1(setScrollPosition, function(param) {
            return $iv6Yc._1($7GW0c.$$Window.scrollY, undefined);
        });
    };
    $g85JO.useEffect(function() {
        if (enabled) window.addEventListener("scroll", onScroll, {
            capture: false,
            passive: true,
            once: false
        });
        return function(param) {
            window.removeEventListener("scroll", onScroll, {
                capture: false,
                passive: true
            });
        };
    }, [
        enabled
    ]);
    return match[0];
}
 /* react Not a pure module */ 
});

parcelRegister("jLIqo", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $e644dde87e12ab95$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $hBcYV = parcelRequire("hBcYV");

var $aSJcu = parcelRequire("aSJcu");

var $3QcL7 = parcelRequire("3QcL7");
function $e644dde87e12ab95$var$NavMenu__Backdrop(Props) {
    var ctx = $3QcL7.use(undefined);
    var match = $hBcYV.useRouter(undefined);
    var goTo = match.goTo;
    var match$1 = $aSJcu.use(undefined);
    var windowHeight = match$1.windowSize.height;
    var timeoutRef = $g85JO.useRef(undefined);
    var match$2 = ctx.mode;
    var match$3 = match$2 ? [
        0,
        windowHeight
    ] : [
        ctx.positions.siteHeaderSize.height + ctx.positions.siteHeaderSize.top | 0,
        windowHeight - (ctx.positions.siteHeaderSize.height + ctx.positions.siteHeaderSize.top | 0) | 0
    ];
    var $$clearTimeout$1 = function $$clearTimeout$1(param) {
        $2whNH.forEach(timeoutRef.current, function(prim) {
            clearTimeout(prim);
        });
    };
    var handleCloseStart = function handleCloseStart(param) {
        $$clearTimeout$1(undefined);
        timeoutRef.current = $loT9g.some(setTimeout(function(param) {
            $iv6Yc._3(goTo, undefined, undefined, /* NotRendered */ 0);
        }, 50));
    };
    var handleCloseCancel = function handleCloseCancel(param) {
        $$clearTimeout$1(undefined);
    };
    var match$4 = ctx.mode;
    var handleClick = match$4 ? handleCloseStart : undefined;
    var match$5 = ctx.mode;
    var handleMouseEnter = match$5 ? undefined : handleCloseStart;
    var match$6 = ctx.mode;
    var handleMouseLeave = match$6 ? undefined : handleCloseCancel;
    $g85JO.useEffect(function() {
        return $$clearTimeout$1;
    }, []);
    var zIndex = ctx.zIndex > 0 ? ctx.zIndex - 1 | 0 : undefined;
    if (zIndex === undefined) return null;
    var tmp = {
        className: $ezf3v.prefix($1TRFX.make([
            "transition-opacity",
            "fixed bg-black left-0 w-full",
            ctx.isModalOpen ? "" : "pointer-events-none"
        ])),
        style: {
            height: $ezf3v.intToPx(match$3[1]),
            top: $ezf3v.intToPx(match$3[0]),
            zIndex: String(ctx.zIndex - 1 | 0),
            opacity: ctx.isModalOpen ? ctx.modalBackdropOpacity.toString() : "0",
            transitionDuration: $ezf3v.intToMs(ctx.modalTransitionSpeedMs)
        }
    };
    if (handleClick !== undefined) tmp.onClick = $loT9g.valFromOption(handleClick);
    if (handleMouseEnter !== undefined) tmp.onMouseEnter = $loT9g.valFromOption(handleMouseEnter);
    if (handleMouseLeave !== undefined) tmp.onMouseLeave = $loT9g.valFromOption(handleMouseLeave);
    return /*#__PURE__*/ $g85JO.createElement("div", tmp);
}
$e644dde87e12ab95$var$NavMenu__Backdrop.displayName = "NavMenu__Backdrop";
var $e644dde87e12ab95$export$dd44f18ab656f3bb = $e644dde87e12ab95$var$NavMenu__Backdrop;
 /* react Not a pure module */ 
});

parcelRegister("c2FOD", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $8c461bafefa316e7$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $7wIsS = parcelRequire("7wIsS");

var $lhKg5 = parcelRequire("lhKg5");

var $27XcH = parcelRequire("27XcH");

var $2jMpY = parcelRequire("2jMpY");

var $6Ntmr = parcelRequire("6Ntmr");

var $1a0pQ = parcelRequire("1a0pQ");

var $hBcYV = parcelRequire("hBcYV");

var $1QuVJ = parcelRequire("1QuVJ");

var $3QcL7 = parcelRequire("3QcL7");

var $4135i = parcelRequire("4135i");

var $2wB5I = parcelRequire("2wB5I");

var $lihS4 = parcelRequire("lihS4");

var $8E2YL = parcelRequire("8E2YL");
function $8c461bafefa316e7$var$NavMenu__ModalLayout(Props) {
    var children = Props.children;
    var ctx = $3QcL7.use(undefined);
    var match = $hBcYV.useRouter(undefined);
    var goTo = match.goTo;
    var items = $1a0pQ.useItems(undefined, undefined);
    var match$1 = $8E2YL.use(undefined);
    var pdpAddToCartConfirmation = match$1.config.settings.pdpAddToCartConfirmation;
    var match$2 = $lihS4.useCart(undefined);
    var cart = match$2.cart;
    var match$3 = $4135i.useCheckoutAction(undefined);
    var handleCheckoutClick = match$3.onClick;
    var checkoutHref = match$3.href;
    var renderCloseButton = function renderCloseButton(param) {
        var match = ctx.mode;
        if (match) return /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("inline-block px-4 py-2")
        }, /*#__PURE__*/ $g85JO.createElement($27XcH.make, {
            onClick: function onClick(param) {
                $iv6Yc._3(goTo, undefined, undefined, /* NotRendered */ 0);
            },
            clear: true,
            iconSize: /* Smallest */ 4,
            labelSize: /* Smallest */ 4,
            icon: /*#__PURE__*/ $g85JO.createElement($7wIsS.UilTimes.make, {
                size: /* Px */ {
                    _0: 20
                }
            }),
            label: "Close"
        }));
        else return /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("inline-block relative py-4")
        }, /*#__PURE__*/ $g85JO.createElement($27XcH.make, {
            onClick: function onClick(param) {
                $iv6Yc._3(goTo, undefined, undefined, /* NotRendered */ 0);
            },
            icon: /*#__PURE__*/ $g85JO.createElement($7wIsS.UilTimes.make, {
                size: /* Px */ {
                    _0: 20
                }
            })
        }));
    };
    var renderCheckoutButton = function renderCheckoutButton(param) {
        if (checkoutHref === undefined && handleCheckoutClick === undefined) return null;
        var tmp = {
            clear: true,
            iconSize: /* Smallest */ 4,
            icon: /*#__PURE__*/ $g85JO.createElement($lhKg5.make, {
                size: 20
            })
        };
        if (handleCheckoutClick !== undefined) tmp.onClick = $loT9g.valFromOption(handleCheckoutClick);
        var tmp$1 = $2jMpY.fromInt(99, undefined, cart.itemCount);
        if (tmp$1 !== undefined) tmp.badge = $loT9g.valFromOption(tmp$1);
        if (checkoutHref !== undefined) tmp.href = $loT9g.valFromOption(checkoutHref);
        return /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("inline-block px-4 py-2 relative")
        }, /*#__PURE__*/ $g85JO.createElement($27XcH.make, tmp), /*#__PURE__*/ $g85JO.createElement($6Ntmr.make, {
            productDirection: /* Bottom */ 1,
            tooltipDirection: /* Left */ 2,
            addedLabel: pdpAddToCartConfirmation,
            className: $ezf3v.prefix("absolute top-0 left-0 w-full h-full")
        }));
    };
    var match$4 = ctx.mode;
    var paddingX = match$4 || ctx.threeColumnLayout ? undefined : "5%";
    var match$5 = ctx.mode;
    if (match$5) {
        var tmp = {
            className: $ezf3v.prefix("py-3 text-lg"),
            offset: 9,
            hideOnEmpty: true,
            centered: false
        };
        if (items !== undefined) tmp.items = $loT9g.valFromOption(items);
        return /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("flex flex-col h-full overflow-hidden")
        }, ctx.isModalOpen ? /*#__PURE__*/ $g85JO.createElement($2wB5I.make, {}) : null, /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("flex flex-col sticky top-0 z-10 flex-shrink-0 w-full bg-main")
        }, /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("flex")
        }, /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("flex-grow")
        }, renderCloseButton(undefined)), /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("flex-shrink-0")
        }, renderCheckoutButton(undefined))), /*#__PURE__*/ $g85JO.createElement($1QuVJ.make, tmp), /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("absolute pointer-events-none bottom-0 left-0 w-full border-b border-primary opacity-5")
        })), /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("relative overflow-hidden flex-grow")
        }, children));
    }
    var tmp$1 = {
        maxHeight: $ezf3v.intToPx(ctx.positions.modalMaxHeight)
    };
    if (paddingX !== undefined) tmp$1.paddingRight = paddingX;
    if (paddingX !== undefined) tmp$1.paddingLeft = paddingX;
    return /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("w-full mx-auto flex"),
        style: tmp$1
    }, ctx.isModalOpen ? /*#__PURE__*/ $g85JO.createElement($2wB5I.make, {}) : null, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("flex-grow ml-3 relative overflow-hidden")
    }, children), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("flex-shrink-0 px-3")
    }, renderCloseButton(undefined)));
}
$8c461bafefa316e7$var$NavMenu__ModalLayout.displayName = "NavMenu__ModalLayout";
var $8c461bafefa316e7$export$dd44f18ab656f3bb = $8c461bafefa316e7$var$NavMenu__ModalLayout;
 /* react Not a pure module */ 
});


parcelRegister("hM6fK", function(module, exports) {

$parcel$export(module.exports, "preload", function () { return $cf0bc514c141a324$export$513ccb98c53b8039; });
$parcel$export(module.exports, "make", function () { return $cf0bc514c141a324$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7tAuM = parcelRequire("7tAuM");

var $cf0bc514c141a324$var$component = (0, $7tAuM.default)(function() {
    return (parcelRequire("gkuBW"));
});
function $cf0bc514c141a324$var$ProductDetailsPage_Lazy(Props) {
    return /*#__PURE__*/ $g85JO.createElement($cf0bc514c141a324$var$component, Props);
}
$cf0bc514c141a324$var$ProductDetailsPage_Lazy.displayName = "ProductDetailsPage_Lazy";
var $cf0bc514c141a324$export$513ccb98c53b8039 = $cf0bc514c141a324$var$component.preload;
var $cf0bc514c141a324$export$dd44f18ab656f3bb = $cf0bc514c141a324$var$ProductDetailsPage_Lazy;
 /*  Not a pure module */ 
});
parcelRegister("gkuBW", function(module, exports) {












module.exports = Promise.all([
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("67jxL")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("aGl6m")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("5PtUs")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("bumwY")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("fbQqy")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("WepAH"))
]).then(function() {
    return parcelRequire("Tbt6s");
});

});



})();
//# sourceMappingURL=NavMenuOverlay.bs.73b538f6.js.map
